const config = {
  title: "Itinerari di Cicerone (CiceroNET)",
  titleHtml: "",
  logo: require("../assets/img/positivo-nero.png"),
  logoPositivo: require("../assets/img/logo-home.png"),
};

export default config;
